import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconNewsletter = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 39 27' >
    <title>{t('Newsletter')}</title>
    <g fill={fill} fillRule='evenodd'>
      <path d='M0 .00007222V5.77785l19.37975 9.75L39 5.77785V.00007222z' />
      <path d='M19.37975 18.4165222l-6.1388889-3.37025L0 26.7220778h39L25.3980278 15.0462722zM27.775475 13.9968472l11.2244167 10.1678056V8.32270833zM0 24.1644722l11.2244167-10.1678055L0 8.32252778z' />
    </g>
  </svg>
)

export default Icon(IconNewsletter)
